import React, { forwardRef } from 'react';
import { Play } from 'lucide-react';
import * as images from '../../assets/images';
import './HeroVisual.css';

/* Sparks sit along the rising forecast line — soft drift + twinkle */
const dataSparks = [
  { left: '30%', bottom: '24%', size: 5, delay: 0.0, duration: 3.6, drift: 10, tone: 'gold', kind: 'rise' },
  { left: '38%', bottom: '31%', size: 4, delay: 0.5, duration: 4.2, drift: 12, tone: 'cyan', kind: 'twinkle' },
  { left: '45%', bottom: '28%', size: 6, delay: 1.1, duration: 3.4, drift: 14, tone: 'gold', kind: 'rise' },
  { left: '51%', bottom: '40%', size: 4, delay: 0.2, duration: 3.9, drift: 11, tone: 'cyan', kind: 'rise' },
  { left: '57%', bottom: '36%', size: 5, delay: 1.5, duration: 4.4, drift: 16, tone: 'gold', kind: 'twinkle' },
  { left: '63%', bottom: '49%', size: 4, delay: 0.7, duration: 3.5, drift: 13, tone: 'cyan', kind: 'rise' },
  { left: '69%', bottom: '44%', size: 6, delay: 1.8, duration: 4.0, drift: 18, tone: 'gold', kind: 'rise' },
  { left: '74%', bottom: '56%', size: 4, delay: 0.4, duration: 4.5, drift: 12, tone: 'cyan', kind: 'twinkle' },
  { left: '80%', bottom: '52%', size: 5, delay: 1.3, duration: 3.3, drift: 15, tone: 'gold', kind: 'rise' },
  { left: '47%', bottom: '50%', size: 4, delay: 2.2, duration: 3.8, drift: 10, tone: 'cyan', kind: 'twinkle' },
  { left: '60%', bottom: '58%', size: 5, delay: 0.9, duration: 4.3, drift: 14, tone: 'gold', kind: 'rise' },
  { left: '72%', bottom: '64%', size: 5, delay: 2.0, duration: 3.7, drift: 17, tone: 'cyan', kind: 'rise' },
  { left: '84%', bottom: '60%', size: 4, delay: 0.1, duration: 4.1, drift: 11, tone: 'gold', kind: 'twinkle' },
  { left: '34%', bottom: '38%', size: 4, delay: 2.5, duration: 4.6, drift: 9, tone: 'cyan', kind: 'rise' },
  { left: '66%', bottom: '42%', size: 5, delay: 1.0, duration: 3.5, drift: 13, tone: 'gold', kind: 'rise' },
  { left: '78%', bottom: '70%', size: 4, delay: 1.6, duration: 4.4, drift: 16, tone: 'cyan', kind: 'twinkle' },
  { left: '54%', bottom: '46%', size: 3.5, delay: 2.7, duration: 3.9, drift: 8, tone: 'gold', kind: 'twinkle' },
  { left: '41%', bottom: '34%', size: 3.5, delay: 2.1, duration: 4.7, drift: 10, tone: 'cyan', kind: 'rise' },
  { left: '76%', bottom: '48%', size: 5, delay: 0.6, duration: 3.6, drift: 14, tone: 'gold', kind: 'rise' },
  { left: '58%', bottom: '62%', size: 4, delay: 1.9, duration: 4.0, drift: 12, tone: 'cyan', kind: 'rise' },
];

/**
 * Landing-page hero visual — forecasting graphic + play-demo control.
 * Kept in its own file so image blending / layout can be tuned independently.
 */
const HeroVisual = forwardRef(function HeroVisual(_props, playRef) {
  return (
    <div className="de-hero-visual">
      <div className="de-hero-art">
        <div className="de-hero-img-wrap">
          <img
            className="de-hero-img"
            src={images.heroForecastDemand}
            alt="AI demand forecasting visualization"
          />
          <span className="de-hero-img-glow" aria-hidden="true" />
          <div className="de-hero-sparks" aria-hidden="true">
            {dataSparks.map((s, i) => (
              <span
                key={i}
                className={`de-hero-spark de-hero-spark--${s.tone} de-hero-spark--${s.kind}`}
                style={{
                  left: s.left,
                  bottom: s.bottom,
                  width: s.size,
                  height: s.size,
                  '--spark-drift': `${s.drift}px`,
                  animationDelay: `${s.delay}s`,
                  animationDuration: `${s.duration}s`,
                }}
              />
            ))}
          </div>
        </div>
        <button
          className="de-hero-play"
          ref={playRef}
          type="button"
          aria-label="Play demo"
        >
          <span className="de-hero-play-core">
            <Play size={22} strokeWidth={2.5} fill="currentColor" />
          </span>
          <span className="de-hero-play-label">Play Demo</span>
        </button>
      </div>
    </div>
  );
});

export default HeroVisual;
